<ng-container *ngIf="action$ | async as action">
  <div
    [pTooltip]="action.tooltip ?? action.description"
    tooltipPosition="top"
    style="display: inline-block;"
  >
    <p-button
      ntapDebounceClick
      [icon]="'pi ' + (action.icon ? 'pi-' + action.icon : 'pi-hidden')"
      [ngClass]="action.name + ' hide-label-responsive'"
      [label]="action.description"
      (onClick)="executeAction($event)"
      [disabled]="(isDisabled$ | async) ?? true"
    ></p-button>
  </div>
</ng-container>
<p-confirmDialog #cd header="Potvrda" appendTo="body" [key]="key">
  <ng-template pTemplate="footer">
    <button
      type="button"
      pButton
      icon="pi pi-times"
      label="Odustani"
      (click)="cd.reject()"
    ></button>
    <button
      type="button"
      pButton
      icon="pi pi-check"
      label="Potvrdi"
      (click)="cd.accept()"
    ></button>
  </ng-template>
</p-confirmDialog>
